define(function() {
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const theModel = require('civicsModels/portal/wizard_type_model');

	return IpsModelCollection.extend({
		model: theModel,
		urlRoot: '/delegate/civics-api/api/portal/wizardtypes',
		initialize:function()
		{
				this.on( "change:descriptionText", function(){
					}
				, this);
				this.on( "change", function(){
					}
				, this);
		}
	});
});
